import React from 'react'
import { styled } from 'styled-components';
  /* background-image: url(${require('../../assets/linaria-logomark.svg')}); */
const Div = styled.div`
  width: calc(100vw - 64px);
  max-width: ${props => props.fullwidth ? '100vw' : '1300px'};
  margin-left: auto;
  margin-right: auto;
  padding-left: 54px;
  padding-right: 54px;
  margin-top: ${props => props.mt0 ? '0px' : '75px'};
  margin-bottom: ${props => props.mb0 ? '0px' : '75px'};
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  border-radius: ${props => props.fullwidth ? '0px' : '30px'};
  @media(max-width: 768px) {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: ${props => props.mt0 ? '0px' : '35px'};
    margin-bottom: ${props => props.mb0 ? '0px' : '35px'};
  }
`

const Container = ({ children, backgroundimage, fullwidth, mb0, mt0 }) => {

  if(backgroundimage) {
    return (
      <Div mb0={mb0} mt0={mt0} fullwidth={fullwidth} style={{ backgroundImage: `url(${backgroundimage})`}}>
        {children}
      </Div>
    )
  } else {
    return (
      <Div mb0={mb0} mt0={mt0} fullwidth={fullwidth}>
        {children}
      </Div>
    )
  }

}

export default Container;
